import { Link } from 'react-router-dom';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import AddIconImage from '../../shared/svg/plus.svg';
import CompletedIconImage from '../../shared/svg/check.svg';

import ImageCard from '../../components/ImageCard';

import './index.scss';
import ListPage from '../../layouts/ListPage';

function RecipesMenu() {

  const profileCompletionChecks = [
    {
      title: 'Beef Cuts',
      completed: true,
      uri: '/beef-cuts'
    },
    {
      title: 'Recipe Library',
      completed: true,
      uri: '/recipes'
    },
    {
      title: 'Cooking Methods',
      completed: true,
      uri: '/cooking-methods'
    },
  ];

  return (
    <ListPage
      title={'Content Management'}
      description={'View and manage recipes, beef cuts, cooking methods, and more.'}
      breadcrumbsLinks={[
        {
          url: '/',
          content: 'Content Library',
        },
      ]}
    >
      <Box className="check-icon" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {profileCompletionChecks.map((check) => (
            <Grid
              key={check.title}
              item
              xs={6}
              md={4}
              lg={3}
              xl={2}
            >
              <Link to={check.uri}>
                <ImageCard
                  item={{
                    title: check.title,
                    description: check.description,
                    url: check.completed ? CompletedIconImage : AddIconImage
                  }}
                  icon={true}
                  imageBackground='#fff'
                />
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ListPage>
  )
}

export default RecipesMenu;